import React, { useState } from 'react';
import axios from 'axios';
import { Bio } from '../../data/constants';
import { FaEnvelope, FaMapMarkerAlt, FaGithub, FaLinkedin } from 'react-icons/fa';
import useReveal from '../../hooks/useReveal';
import './styles.css';

export default function Contact() {
  const ref = useReveal();
  const [form, setForm] = useState({ name: '', email: '', subject: '', message: '' });
  const [status, setStatus] = useState('idle'); // idle | sending | success | error

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus('sending');
    try {
      await axios.post('https://contact-email-microservice.onrender.com/contact', form);
      setStatus('success');
      setForm({ name: '', email: '', subject: '', message: '' });
      setTimeout(() => setStatus('idle'), 4000);
    } catch {
      setStatus('error');
      setTimeout(() => setStatus('idle'), 4000);
    }
  };

  return (
    <section className="section contact" id="contact" ref={ref}>
      <p className="section-label reveal">Contact</p>
      <h2 className="section-title reveal reveal-delay-1">Let's Work Together</h2>
      <p className="section-subtitle reveal reveal-delay-2">
        Have a project idea or opportunity? I'd love to hear from you.
      </p>

      <div className="contact__grid reveal reveal-delay-3">
        {/* Info side */}
        <div className="contact__info">
          <div className="contact__info-item">
            <FaEnvelope className="contact__info-icon" />
            <div>
              <span className="contact__info-label">Email</span>
              <a href={`mailto:${Bio.email}`} className="contact__info-value">{Bio.email}</a>
            </div>
          </div>
          <div className="contact__info-item">
            <FaMapMarkerAlt className="contact__info-icon" />
            <div>
              <span className="contact__info-label">Location</span>
              <span className="contact__info-value">{Bio.location}</span>
            </div>
          </div>

          <div className="contact__divider" />

          <p className="contact__cta-text">Find me on</p>
          <div className="contact__socials">
            <a href={Bio.github} target="_blank" rel="noreferrer" className="contact__social"><FaGithub /></a>
            <a href={Bio.linkedin} target="_blank" rel="noreferrer" className="contact__social"><FaLinkedin /></a>
          </div>
        </div>

        {/* Form */}
        <form className="contact__form" onSubmit={handleSubmit}>
          <input
            type="text" name="name" placeholder="Name" required
            value={form.name}
            onChange={(e) => setForm({ ...form, name: e.target.value })}
            className="contact__input"
          />
          <input
            type="email" name="email" placeholder="Email" required
            value={form.email}
            onChange={(e) => setForm({ ...form, email: e.target.value })}
            className="contact__input"
          />
          <input
            type="text" name="subject" placeholder="Subject" required
            value={form.subject}
            onChange={(e) => setForm({ ...form, subject: e.target.value })}
            className="contact__input"
          />
          <textarea
            name="message" placeholder="Your message..." rows="5" required
            value={form.message}
            onChange={(e) => setForm({ ...form, message: e.target.value })}
            className="contact__input contact__textarea"
          />
          <button
            type="submit"
            className={`contact__submit ${status === 'success' ? 'contact__submit--success' : ''}`}
            disabled={status === 'sending'}
          >
            {status === 'idle' && 'Send Message →'}
            {status === 'sending' && 'Sending...'}
            {status === 'success' && 'Sent Successfully ✓'}
            {status === 'error' && 'Failed — Try Again'}
          </button>
        </form>
      </div>
    </section>
  );
}
